import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, Grid, Divider } from "@mui/material";
import { useSelector } from 'react-redux';
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import { DefaultCard } from "../../assets/styled-components/card";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import BasicDetails from "./BasicDetails";
import AttachmentTC from "./AttachementsTC";
import VerticalLinearStepper from "../commoncomponents/stepper";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import TCOthers from "./TCOthers";
import TestingCommissionList from "./TestingCommissionList";
import PageTitle from "../commoncomponents/PageTitle";
import { useLocation } from "react-router-dom";

const TCAssetMain = () => {

  const { currentPage, currentPageMandatoryFields } = useSelector(state => state.TestingCommissionDetails?.stepper);
  const basicDetails = useSelector(state => state.TestingCommissionDetails.basicDetails);
  const tcDetails = useSelector(state => state.TestingCommissionDetails.tcDetails);
  const [page, setPage] = useState(currentPage);
  const location = useLocation();
  const [authoriseTick, setAuthoriseTick] = useState(0);
  useEffect(() => {
    setPage(currentPage);
  }, [currentPage]);


  const renderPageContent = () => {
    switch (page) {
      case "T&CListing":
        return (
          <TestingCommissionList />
        );

      case "Basic Details":
        return (
          <BasicDetails />
        );

      case "Others":
        return (
          <TCOthers />
        );

      case "Attachments":
        return (
          <AttachmentTC setAuthoriseTick={setAuthoriseTick}/>
        );

      default:
        return null;
    }
  };

  const renderMandatoryFields = () => {
    // Check if mandatoryFieldsFind is undefined before mapping
    if (currentPageMandatoryFields === undefined) {
      return null;
    }

    return currentPageMandatoryFields.map((field, index) => (
      <Grid
        key={index}
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          marginBottom: "5px",
        }}
      >
        {field.isMandatory === true ?
          <>
            {field.valueFilled === false ? <HighlightOffRoundedIcon
              color="disabled"
              sx={{ fontSize: 16, marginRight: "5px" }}
            /> :
              <CheckCircleOutlineIcon
                color="success"
                sx={{ fontSize: 16, marginRight: "5px" }}
              />}
            <Typography
              variant='labelSm'
              color={'text.grey'}
              component={'label'}
              sx={{
                fontSize: {
                  xs: '1rem', // Small size for extra small screens
                  sm: '0.875rem', // Slightly larger for small screens
                  md: '1rem', // Default size for medium screens and up
                },
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: {
                  xs: '150px', // Maximum width for extra small screens
                  sm: '200px', // Maximum width for small screens
                  md: '250px', // Maximum width for medium screens
                },
              }}
            >
              {field.type}
            </Typography>
          </>
          :
          null
        }
      </Grid>
    ));
  };

  const checkSteppsForTC = (percentage) => {
    let stepsForAsset = [
      { label: "Basic Details", key: "Basic Details", value: "0", labelId: 0 },
      { label: "Other Details", key: "Others", value: "35", labelId: 1 },
      { label: "Attachments", key: "Attachments", value: "70", labelId: 2+authoriseTick },
    ];
    if (!percentage && !tcDetails?.isEditMode && !tcDetails?.isViewMode) { //this condition is for create mode
      return stepsForAsset;
    }
    if (percentage && (tcDetails?.isEditMode || tcDetails?.isViewMode)) { //this condition is for edit mode or view mode
      const updatedSteps = stepsForAsset?.map((item) => ({ ...item, value: `${percentage}` }));
      return updatedSteps;
    }

    if (percentage && basicDetails?.isEditMode) {
      const updatedSteps = stepsForAsset?.map((item) => ({ ...item, value: `${percentage}` }));
      return updatedSteps;
    }

    return stepsForAsset;
  }

  const mode = location?.state?.mode;
  const pageTitle = mode === "view" ? "View Testing & Commissioning" : (mode === "edit" ? "Edit Testing & Commissioning" : "Create Testing & Commissioning");
  const percentage = tcDetails?.processingpercentage;

  return (
    <>
      <BreadcrumbBar>
        <PageTitle title={pageTitle} />
      </BreadcrumbBar>
      <Box mt={{ xs: 1, sm: 2 }}>
        <Grid container sx={{ display: "flex" }} spacing={2}>
          {/* left section */}
          <Grid item xs={12} sm={3.4} md={2.2}>
            <DefaultCard sx={{ height: "100%" }}>
              <Box pb={{ xs: 1, sm: 2 }}>
                <VerticalLinearStepper page={page} steps={checkSteppsForTC(percentage)} />
                {page === "Basic Details" && (
                  <>
                    <Divider variant="middle" sx={{ marginBottom: "10%" }} />
                    <Typography color='text.primary' mb={2}>
                      You can go to the next step once you complete these
                      following mandatory input fields
                    </Typography>
                    {renderMandatoryFields()}
                  </>
                )}
              </Box>
            </DefaultCard>
          </Grid>

          {/* right section */}
          <Grid item xs={12} sm={8.6} md={9.8}>
            <DefaultCard sx={{ height: "100%" }}>
              {renderPageContent()}
            </DefaultCard>
          </Grid>
        </Grid>
      </Box>



    </>
  );
}

export default TCAssetMain;

